import { render, staticRenderFns } from "./useDetail.vue?vue&type=template&id=8ef2fcc4&scoped=true"
import script from "./useDetail.vue?vue&type=script&lang=js"
export * from "./useDetail.vue?vue&type=script&lang=js"
import style0 from "./useDetail.vue?vue&type=style&index=0&id=8ef2fcc4&prod&lang=scss"
import style1 from "./useDetail.vue?vue&type=style&index=1&id=8ef2fcc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef2fcc4",
  null
  
)

export default component.exports